import { ChatProvider, ChatSession } from "../../chatbotV2";
import { TaskLabels, TeamMateComponentProps } from "../types";

const AlertManagerDisplay = ({
  urls,
  requestParams,
  context,
  contextOptions,
}: TeamMateComponentProps) => {
  const validateRequest = async (data: { context: ChatSession["context"] }) => {
    console.log(data);
  };
  return (
    <div className="al-w-full al-flex-shrink-0">
      <div className="al-h-full al-w-full">
        <ChatProvider
          initialValidation={validateRequest}
          taskLabel={TaskLabels.AlertManager}
          urls={urls}
          helloMessage={
            <div>
              {
                "I'm your AI teammate, here to create alerts for you. Tell me what do you want to set alert for?"
              }
            </div>
          }
          fileUploadProps={{
            allowedFiles: ".sql",
            contextFieldKey: "query",
          }}
          requestParams={requestParams}
          context={context}
          contextOptions={contextOptions}
          placeholder="Alert me when warehouse COMPUTE_WH incurs more than $1000 in the last 7 days"
        />
      </div>
    </div>
  );
};

export default AlertManagerDisplay;
